import { api, SA_ORG_KEY } from "@/lib/api";
import { DEMO_ORG_ID, DEMO_FLAG_KEY } from "@/components/DemoModeCard";
import { localToday } from "@/lib/dates";

export const FLEET_DEMO_ORG_ID = "org_demo_fleet";

export const PRESENT_KEY = "showcase_present";

export async function armDemo() {
  await api.post("/demo/enable");
  localStorage.setItem(DEMO_FLAG_KEY, "1");
  localStorage.setItem(SA_ORG_KEY, DEMO_ORG_ID);
  localStorage.removeItem("plant_id");
}

export async function armFleetDemo() {
  await api.post("/demo/fleet/enable");
  localStorage.setItem(DEMO_FLAG_KEY, "1");
  localStorage.setItem(SA_ORG_KEY, FLEET_DEMO_ORG_ID);
  localStorage.removeItem("plant_id");
}

// Ordered walk-through of the page demos. `go` resolves the URL to open (after any setup call).
export const TOUR = [
  { key: "war-room", title: "War Room Dispatch", go: async () => "/war-room" },
  { key: "dispatch", title: "Classic Dispatch", go: async () => "/dispatch?classic=1" },
  { key: "fleet-health", title: "Fleet Health", go: async () => "/fleet-health" },
  { key: "daily-report", title: "Daily Report", go: async () => `/daily-summary?date=${localToday()}` },
  { key: "driver", title: "Driver App", go: async () => { await api.post("/demo/driver-seat"); return "/driver"; } },
  { key: "invoicing", title: "Auto-Invoicing", go: async () => `/invoices?daily=1&date=${localToday()}` },
  { key: "cockpit", title: "One-Touch Batching", go: async () => "/batcher" },
];

export function presentingKey() {
  try { return sessionStorage.getItem(PRESENT_KEY); } catch { return null; }
}

export async function launchDemo(key) {
  const step = TOUR.find((t) => t.key === key);
  await armDemo();
  const url = await step.go();
  sessionStorage.setItem(PRESENT_KEY, key);
  window.location.assign(url);
}

export async function launchFleetDemo() {
  await armFleetDemo();
  sessionStorage.setItem(PRESENT_KEY, "fleet-war-room");
  window.location.assign("/war-room");
}

export function exitPresentation() {
  sessionStorage.removeItem(PRESENT_KEY);
  window.location.assign("/showcase");
}
